
import { OnInit, Component, ViewChild, ViewEncapsulation, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { MFAPreferMasterPayload, MFAPrefrences, MFAQRCodePayload, MFASecurityQuestionAnswer, MFAUserPreferences, MFASettingsCombined } from '@shared/models/auth.interface';
import { catchError } from 'rxjs';
import { SnackbarService, LoadingService } from '@shared/services/core';
import { LogService } from '@shared/services/core/log.service';
import { Router } from '@angular/router';
import { MfaDataService } from '@shared/services/mfa-data.service';
import { AuthMFAService } from '@shared/services/auth/auth-mfa.service';
import { finalize, of, Subscription } from 'rxjs';
import { ExtendedLogDetails } from '@shared/models/log.interface';
import { SessionService } from '@shared/services/auth/session.service';
import { appQRdata, MFAPrefResponse, retrySendCodepayload, retrySendCodeResponse, SavePreferencesPayload } from '@shared/models/mfa-prefrences.interface';
import { APIResponse } from '@shared/models/shared-data.interface';



@Component({
  selector: 'app-mfa-settings',
  templateUrl: './mfa-settings.component.html',
  styleUrls: ['./mfa-settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MfaComponent implements OnInit {
  public form: FormGroup;
  public MFAForm: FormGroup;
  public valueAuthOptions: Array<string> = ['Option 1', 'Option 2', 'Option 3'];
  public selectedStepIndex: number = 1; // Default to second step
  @ViewChild('stepper') private stepper!: MatStepper;
  public downloadAppStep: FormGroup;
  public showVerificationTabs: boolean = false;
  public otpArray = Array(6); // Adjust the length based on OTP digits
  public otpValues: string[] = new Array(6).fill('');
  public QrCodeUrl!: string;
  public appQRdata!: appQRdata;
  mfaData: MFASettingsCombined | null = null;
  public otpTouched = false;
  invalidOtp: boolean = false;
  activeTab!: string;
  userMfaPreferences: any;
  public optionList: any[] = [];
  securityQuestionForm: FormGroup;
  public questions: MFASecurityQuestionAnswer[] = [];
  public rememberMe = false;
  private loginTriggerSub!: Subscription;
  private mfaDataSub!: Subscription;
  @ViewChild('verificationTabs') verificationTabs!: ElementRef;
  expiredOTP: boolean = false;
  VerifyButtonHide:boolean= true;

  constructor(private formBuilder: FormBuilder,
    public mfaDataService: MfaDataService,
    private loadingService: LoadingService,
    private snackbarService: SnackbarService,
    private logService: LogService,
    private authService: AuthMFAService,
    public sessionService: SessionService,
    private router: Router
  ) {
    this.form = this.formBuilder.group({
      code: new FormControl("", [
        Validators.required,
        Validators.pattern(/^1234$/),
      ]),
    });

    this.downloadAppStep = this.formBuilder.group({
      accountInputCtrl: ['',],
      keyInputCtrl: ['',]
    });

    this.MFAForm = this.formBuilder.group({
      defaultMFA: new FormControl(''),
      PhoneCode: new FormControl('', Validators.required),
      PhoneNo: new FormControl('', Validators.required),
      SecruityQues1: new FormControl(false, Validators.required),
      SecruityQues2: new FormControl(false, Validators.required),
    })

    this.securityQuestionForm = this.formBuilder.group({
      question1Id: [null, Validators.required],
      question1: [null, Validators.required],
      answer1: ['', [Validators.required, Validators.maxLength(100)]],
      question2Id: [null, Validators.required],
      question2: [null, Validators.required],
      answer2: ['', [Validators.required, Validators.maxLength(100)]]
    });
  }

  ngOnInit(): void {
    this.mfaDataSub = this.mfaDataService.mfaData$.subscribe((data: MFASettingsCombined | null) => {
      this.mfaData = data;
      if (!this.mfaData) {
        // If application realod i.e Data missing in service, redirect to login
        this.router.navigate(['/login']);
      } else {
        this.activeTab = this.mfaData?.clientMfa.DefaultAuth;
        if(this.activeTab === 'AUTHY')
        {
          if(this.mfaData.responseStatus === 200)
          {
            
           this.snackbarService.showSuccessSnackBar('Success', 'A verification code has been sent to your registered mobile number.', 'none');
            
          }
          else
          {
            this.VerifyButtonHide =  this.mfaData?.clientMfa.UserPhoneNumber === null ? false : true;
              let responseMessage = 'Unable to resend verification code. Please check if your phone number is provided, or try again later as the SMS service may be unavailable.';
              if (typeof this.mfaData?.responseMessage === 'string' && this.mfaData?.responseMessage.toLowerCase() === 'low sms credit') {
               let PurchaseSMSCredits = '<a href="https://knowledge.entireonhire.com/en/purchase-sms-credits-here-1" target="_blank" class="snackbar-link"> Purchase SMS Credits </a>';
               responseMessage = `Your SMS credits are low. Please click ${PurchaseSMSCredits} to link to add credits to your account and continue receiving OTP messages.`;
              }
            this.snackbarService.showErrorSnackBar('Error', responseMessage, 'none');
          }
        }
        else if (this.activeTab === 'EMAIL')
        {
          this.snackbarService.showSuccessSnackBar('Success', 'A verification code has been sent to your registered Email.', 'none');
        }
        //this.activeTab === 'EMAIL' ? this.snackbarService.showSuccessSnackBar('Success', 'A verification code has been sent to your registered Email.', 'none')
         // : this.activeTab === 'AUTHY' ? this.snackbarService.showSuccessSnackBar('Success', 'A verification code has been sent to your registered mobile number.', 'none') : '';

        this.questions = this.mfaData?.clientMfa?.Questions || [];
        if (this.questions.length > 0) {
          this.VerifyButtonHide = true;
          this.securityQuestionForm.patchValue({
            question1: this.questions[0].Id,
            question1Id: this.questions[0].Question,
            question2: this.questions[1].Id,
            question2Id: this.questions[1].Question
          });
          this.securityQuestionForm.get('question1')?.disable();
          this.securityQuestionForm.get('question2')?.disable();
        }
        this.VerifyButtonHide = false;
      }
    });

    this.loginTriggerSub = this.mfaDataService.loginTriggerSubject.subscribe((msg: string | { error: string } | { otp: string; mfaAuthType: string }) => {
      if (typeof msg === 'string' || ('otp' in msg && 'mfaAuthType' in msg)) {
        this.invalidOtp = false;
        this.otpTouched = false;
        this.expiredOTP = false;
        return;
      }

      if ('error' in msg) {
        const isInvalid = msg.error === 'INVALID_OTP';
        const isExpired = msg.error === 'INVALID_EXPIRED';
        this.expiredOTP = isExpired;
        this.invalidOtp = isInvalid;
        this.otpTouched = isInvalid;
        if (msg.error === '' && this.mfaData?.mfaPref?.isPreferenceSet === 0 && this.stepper) {
          this.clearOtp();
          //this.stepper.next();
          const jti = this.mfaDataService.jti;
          if (jti) {
            const tokenKey = this.sessionService.getToken(jti);
            this.getPrefrencesMaster(jti, tokenKey);
          } else {
            console.error("jti is null and cannot be used.");
          }
        }

      }

    });

    //   if(this.mfaData?.mfaPref?.isPreferenceSet === 0) {
    //     const payload:MFAQRCodePayload={
    //         'clientId': this.mfaData?.clientMfa.userId || '', 
    //         'Action':'Add',
    //         'AccessCode': this.mfaData?.clientMfa.CompanyCode || ''
    //     }
    //     this.mfaDataService.fetchQrCodeIfNeeded(payload);
    // }

    // if(this.mfaData?.clientMfa?.DefaultAuth === 'APP') {
    //     this.get2FAQRCode();
    // }

    this.initializeOptionList();
  }

  initializeOptionList() {
    this.optionList = [
      {
        key: 'RESEND',
        icon: 'fa-rotate-right',
        label: 'page.MFASettings.matStepLabel.step2.resendCode',
        desc: 'page.MFASettings.matStepLabel.step2.resendCodeDesc',
        click: () => {
          if (this.activeTab === 'EMAIL' || this.activeTab === 'AUTHY') {
            this.showVerificationTabs = false;
            this.onResendCode();
          }
        },
        show: () => this.activeTab !== 'HINT' && this.activeTab !== 'APP'
      },
      {
        key: 'AUTHY',
        icon: 'fa-message',
        label: 'page.MFASettings.matStepLabel.step2.smsbtn',
        desc: 'page.MFASettings.matStepLabel.step2.smsbtnDesc',
        click: () => { this.activeTab = 'AUTHY'; this.showVerificationTabs = false; this.onResendCode() },
        show: () => this.activeTab !== 'AUTHY'
      },
      {
        key: 'HINT',
        icon: 'fa-circle-question',
        label: 'page.MFASettings.matStepLabel.step2.secruityQues',
        desc: 'page.MFASettings.matStepLabel.step2.secruityQuesDesc',
        click: () => { this.activeTab = 'HINT'; this.showVerificationTabs = false; this.VerifyButtonHide = this.mfaData?.clientMfa?.Questions?.length === 0 ? false:true},
        show: () => this.activeTab !== 'HINT'
      },
      {
        key: 'APP',
        icon: 'fa-mobile',
        label: 'page.MFASettings.matStepLabel.step2.Qrcode',
        desc: 'page.MFASettings.matStepLabel.step2.QrcodeDesc',
        click: () => { this.activeTab = 'APP'; this.showVerificationTabs = false; },
        show: () => this.activeTab !== 'APP' && this.mfaData?.clientMfa.DefaultAuth === 'APP'
      },
      {
        key: 'EMAIL',
        icon: 'fa-envelope',
        label: 'page.MFASettings.matStepLabel.step2.emailbtn',
        desc: 'page.MFASettings.matStepLabel.step2.emailbtnDesc',
        click: () => { this.activeTab = 'EMAIL'; this.showVerificationTabs = false; this.onResendCode() },
        show: () => this.activeTab !== 'EMAIL'
      }
    ];
  }

  clearOtp() {
    this.otpTouched = false;
    this.invalidOtp = false;
    this.expiredOTP = false;
    this.otpValues = Array(this.otpArray.length).fill('');
  }

  // Date: 2023-10-05
  // Purpose: Handle input in OTP fields and move focus to the next field when a digit is entered.  
  public onInput(event: any, index: number): void {
    const inputValue = event.target.value;
    if (inputValue.length === 1 && index < this.otpArray.length - 1) {
      const nextInput = event.target.nextElementSibling;
      if (nextInput) {
        nextInput.focus();
      }
    }
  }


  // Date: 2023-10-05
  // Purpose: Handle backspace in OTP fields and move focus to the previous field if the current field is empty.
  public onBackspace(event: any, index: number): void {
    const currentInputValue = this.otpValues[index];
    if (!currentInputValue && index > 0) {
      const prevInput = event.target.previousElementSibling;
      if (prevInput) {
        prevInput.focus();
      }
    } else {
      this.otpValues[index] = '';
    }
  }

  // Date: 2023-10-05
  // Purpose: Validate if all OTP fields are filled with single digits.
  public isOtpValid(): boolean {
    return this.otpValues.every(value => value.trim().length === 1);
  }

  // Date: 2023-10-05
  // Purpose: Combine OTP values, log the submitted OTP, and move to the next step in the stepper.
  public submitOtp(): void {
    this.otpTouched = true;
    const otp = this.otpValues.join('');
    const securityQuestions = this.activeTab == 'HINT' ? this.securityQuestionForm.getRawValue() : null;
    const isSecurityQuestionsValid = this.securityQuestionForm.valid;
    if (!this.isOtpValid && !isSecurityQuestionsValid) {
      // Neither OTP nor security questions are valid, do not proceed
      return;
    }
    this.mfaDataService.rememberMe = this.rememberMe;
    this.mfaDataService.loginTriggerSubject.next({ otp, mfaAuthType: this.activeTab, securityQuestions });

  }

  // Date: 2023-10-05
  // Purpose: resend code logic
  onResendCode() {
    this.clearOtp();
    this.VerifyButtonHide = true;
    this.loadingService.showLoading();
    const payload: retrySendCodepayload = {
      'UserId': this.mfaData?.clientMfa.userId || '',
      'AccessCode': this.mfaData?.clientMfa.CompanyCode || '',
       'AuthTypeCode': this.activeTab//,
      // 'UserEmailId': this.mfaData?.clientMfa.UserEmailId || '',
      // 'UserPhoneNumber': (this.mfaData?.clientMfa.CountryCallingCode + '' + this.mfaData?.clientMfa.UserPhoneNumber)
      //   ? (this.mfaData?.clientMfa.CountryCallingCode + '' + this.mfaData?.clientMfa.UserPhoneNumber)
      //   : '',

    }
    this.authService.retryAuthMFA(payload).pipe(
      finalize(() => {
        this.loadingService.stopLoading();
      }),
      catchError((error: ExtendedLogDetails | undefined) => {
        this.logService.error('Error fetching prefernces', error);
        debugger;
        this.snackbarService.showErrorSnackBar(
          'Error',
          'Failed to Send code. Please try again later.',
          'none'
        );
        return of(null);
      })
    ).subscribe((response: APIResponse<retrySendCodeResponse> | null) => {
      if (response?.HttpStatusCode === 200) {
        if (this.mfaData && this.mfaData.clientMfa) {
          this.mfaData.clientMfa.MFASecretKey = response.Data.MFASecretKey;
        }
          this.activeTab === 'EMAIL' ? this.snackbarService.showSuccessSnackBar('Success', 'A verification code has been sent to your registered Email.', 'none')
            : this.activeTab === 'AUTHY' ? this.snackbarService.showSuccessSnackBar('Success', 'A verification code has been sent to your registered mobile number.', 'none') : '';
        
      } else {
        if(this.activeTab === 'AUTHY')
        {
            this.VerifyButtonHide =  this.mfaData?.clientMfa.UserPhoneNumber === null ? false : true;
            let responseMessage = 'Unable to resend verification code. Please check if your phone number is provided, or try again later as the SMS service may be unavailable.';
            if (typeof response?.Message === 'string' && response.Message.toLowerCase() === 'low sms credit') {
              let PurchaseSMSCredits = '<a href="https://knowledge.entireonhire.com/en/purchase-sms-credits-here-1" target="_blank" class="snackbar-link"> Purchase SMS Credits </a>';
              responseMessage = `Your SMS credits are low. Please click ${PurchaseSMSCredits} to link to add credits to your account and continue receiving OTP messages.`;
            }
            this.snackbarService.showErrorSnackBar('Error', responseMessage, 'none');
        }
      }
    });

  }

  // Date: 2023-10-05
  // Purpose:  SMS logic here
  onSmsMe() { }


  //   get2FAQRCode() {
  //   if(this.mfaData?.clientMfa?.IsAuthenticatorAppConfigured){
  //     return; // If already configured, no need to fetch QR code again
  //   }
  //     this.activeTab = 'APP';
  //     this.loadingService.showLoading();
  //     const payload:MFAQRCodePayload={
  //         'clientId': this.mfaData?.clientMfa.userId || '',
  //         'Action':'Reset', // Reset to fetch new QR code
  //         'AccessCode': this.mfaData?.clientMfa.CompanyCode || ''
  //     }
  //     this.mfaDataService.qrCode$.subscribe((data: appQRdata | null) => {
  //         this.loadingService.stopLoading();
  //         if (data) {
  //           this.appQRdata = data;
  //           this.downloadAppStep.patchValue({
  //             'accountInputCtrl': data.Account,
  //             'keyInputCtrl': data.ManualEntryKey
  //           });
  //         }
  //       });

  //     if (!this.mfaDataService.hasQrCode) {
  //     this.mfaDataService.fetchQrCodeIfNeeded(payload).subscribe(response => {
  //         if (response && response.QrCodeUrl) {
  //             if (this.mfaData?.clientMfa) {
  //               this.mfaData.clientMfa.IsAuthenticatorAppConfigured = true;
  //             }
  //           }
  //     });
  //     // this.authService.getMfaQrCode(payload).pipe(
  //     //     finalize(() => {
  //     //         this.loadingService.stopLoading();
  //     //     }),
  //     //     catchError((error: ExtendedLogDetails | undefined) => {
  //     //       this.logService.error('Error fetching QR code', error);
  //     //       this.snackbarService.showErrorSnackBar(
  //     //         'Error',
  //     //         'Failed to fetch QR code. Please try again later.',
  //     //         'none'
  //     //       );
  //     //       return of(null); 
  //     //     })
  //     //   ).subscribe((response: appQRdata | null) => {
  //     //     if (response) {
  //     //       this.appQRdata = response;

  //     //       this.QrCodeUrl = response.QrCodeUrl;
  //     //       this.downloadAppStep.patchValue({
  //     //         'accountInputCtrl': this.appQRdata.Account,
  //     //         'keyInputCtrl': this.appQRdata.ManualEntryKey
  //     //       });
  //     //     }
  //     //   });
  //   }
  // }

  getActiveStepControl(): boolean {
    switch (this.activeTab) {
      case 'EMAIL':
      case 'AUTHY':
      case 'APP':
        return this.isOtpValid() && this.invalidOtp === false && this.expiredOTP === false && this.invalidOtp;
      case 'HINT':
        return this.securityQuestionForm.valid;
      default:
        return false;
    }
  }

  getPrefrencesMaster(jti: string, tokenKey: string) {
    this.loadingService.showLoading();
    const payload: MFAPreferMasterPayload = {
      'clientId': this.mfaData?.clientMfa.userId || '',
      'isUserPreference': Number(this.mfaData?.mfaPref?.isPreferenceSet)
    }
    this.authService.getMFAPreferences(payload, jti, tokenKey).pipe(
      finalize(() => {
        this.loadingService.stopLoading();
      }),
      catchError((error: ExtendedLogDetails | undefined) => {
        this.logService.error('Error fetching prefernces', error);
        this.snackbarService.showErrorSnackBar(
          'Error',
          'Failed',
          'none'
        );
        return of(null);
      })
    ).subscribe((response: MFAPrefResponse) => {
      if (response) {
        this.userMfaPreferences = response;
        this.stepper.selected!.completed = true;
        this.stepper.next();
      }
    });
  }

  get maskedPhoneNumber(): string {
    const phone = this.mfaData?.clientMfa?.UserPhoneNumber || '';
    return phone ? phone.replace(/\d(?=\d{4})/g, '*') : '';
  }

  get isVerifyButtonEnabled(): boolean {
    switch (this.activeTab) {
      case 'EMAIL':
      case 'AUTHY':
      case 'APP':
        return this.isOtpValid();
      case 'HINT':
        return this.securityQuestionForm.valid;
      default:
        return false;
    }
  }

  ngOnDestroy(): void {
    this.loginTriggerSub.unsubscribe();
    this.mfaDataSub?.unsubscribe();
  }

  toggleVerificationTabs() {
    this.showVerificationTabs = !this.showVerificationTabs;
    // Scroll to the div if it is now visible
    if (this.showVerificationTabs) {
      setTimeout(() => {
        this.scrollToVerificationTabs();
      }, 0); // Use a timeout to ensure the DOM is updated
    }
  }
  scrollToVerificationTabs() {
    if (this.verificationTabs) {
      this.verificationTabs.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  handlePaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text')?.trim();

    if (!pastedData) return;

    // Keep only digits
    const digits = pastedData.replace(/\D/g, '');

    if (!digits) return;

    // Split and fill the OTP array
    for (let i = 0; i < this.otpArray.length; i++) {
      this.otpValues[i] = digits[i] ?? '';
    }

    // Mark OTP as touched
    this.otpTouched = true;

    // Enable verification button if full OTP entered
    // this.isVerifyButtonEnabled = this.otpValues.every(v => v !== '');

    // Move focus to last input
    setTimeout(() => {
      const inputs: NodeListOf<HTMLInputElement> =
        document.querySelectorAll('.otp-input');
      inputs[this.otpArray.length - 1]?.focus();
    });
  }
}